import { useQuery } from "@tanstack/react-query";

import { getProgramsTree } from "../../services/programs";

const useGetProgramsTree = () => {

    const queryFn = async () => {
        return await getProgramsTree();
    };

    return useQuery({
        queryKey: ['programs_tree'],
        queryFn,
        retry: 0,
    });
};

export default useGetProgramsTree;